import styled from "styled-components"

export const Image = styled.img`
${({height, width, size}) => `
  width: ${width || size}px;
  height: ${height || size}px;
`}
`
